module.exports = __webpack_public_path__ + "fonts/OPPOSans H.78f8d5ca.ttf";